import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, DatePicker, Modal, Input, notification } from 'antd';
import moment from 'moment';
import { downloadFile } from 'download-csv';
import axios from 'axios';

const RangePicker = DatePicker.RangePicker;
const FormItem = Form.Item;

class DownloadChartModal extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    defaultRange: PropTypes.arrayOf(PropTypes.number).isRequired,
    tags: PropTypes.arrayOf(PropTypes.object).isRequired,
    granularity: PropTypes.string.isRequired,
    project: PropTypes.string.isRequired,
  };

  downloadData = () => {};

  handleSubmit = e => {
    e.preventDefault();
    const { form, tags } = this.props;
    if (tags.length === 0) {
      notification.error({
        message: 'Error',
        description:
          'You need to add some tags in order to download this as a CSV.',
      });
      return;
    }
    form.validateFields(async (err, values) => {
      const { range, granularity } = values;
      const { project } = this.props;
      const res = await axios.post(
        `https://api.cognitedata.com/api/0.4/projects/${project}/timeseries/dataframe`,
        {
          items: tags.map(t => ({
            tagId: t.value,
            aggregates: t.step ? ['step'] : ['avg'],
          })),
          start: +range[0],
          end: +range[1],
          limit: Math.floor(100000 / tags.length),
          granularity,
        },
        {
          withCredentials: true,
        }
      );
      downloadFile(res.data, 'data.csv');
      notification.success({
        message: 'Success',
        description: 'File download successfully.',
      });
    });
  };

  render() {
    const {
      visible,
      hideModal,
      defaultRange,
      granularity,
      form: { getFieldDecorator },
    } = this.props;
    const formItemLayout = {
      labelCol: { xs: { span: 24 }, sm: { span: 8 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
    };
    return (
      <Modal
        title="Download chart data"
        visible={visible}
        onOk={this.downloadData}
        onCancel={hideModal}
        okText="Download"
        footer={null}
        width={600}
        showTime={{ format: 'HH:mm' }}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Select timeframe">
            {getFieldDecorator('range', {
              initialValue: [moment(defaultRange[0]), moment(defaultRange[1])],
              rules: [{ required: true }],
            })(
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
              />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Select granularity"
            help="Example inputs: 15s, 1m, 5h, 2d"
          >
            {getFieldDecorator('granularity', {
              rules: [{ required: true }],
              initialValue: granularity,
            })(<Input />)}
          </FormItem>
          <FormItem wrapperCol={{ sm: { span: 16, offset: 8 } }}>
            <Button type="primary" htmlType="submit">
              Download as CSV
            </Button>
            <Button
              type="danger"
              onClick={hideModal}
              style={{ marginLeft: '10px' }}
            >
              Close
            </Button>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const Wrapper = Form.create()(DownloadChartModal);

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/DownloadChartModal/DownloadChartModal.js